module.exports = __webpack_public_path__ + "media/images/flags/za-4d355ef5f9de728195c981db10d1c35a.svg";